<template>
  <div>
    <b-card>
      <form
        class="w-100"
        @submit.prevent="form.id ? UpdatePortfolio(form.id) : savePortfolio()"
        ref="formReset"
      >
        <div class="row">
          <div class="col-xl-3">
            <div class="form-group">
              <label for="title">Title *</label>
              <Input
                type="text"
                v-model="form.title"
                placeholder="Title"
                id="title"
              />
              <has-error :form="form" field="title"></has-error>
            </div>
          </div>
          <div class="col-xl-3">
            <div class="form-group">
              <label for="description">Topic</label>
              <Input
                type="text"
                v-model="form.description"
                placeholder="Topic"
                id="description"
              />
              <has-error :form="form" field="description"></has-error>
            </div>
          </div>
          <div class="col-xl-3">
            <div class="form-group">
              <label for="link">Link</label>
              <Input
                type="text"
                v-model="form.link"
                placeholder="Link"
                id="link"
              />
              <has-error :form="form" field="link"></has-error>
            </div>
          </div>
          <div class="col-xl-3">
            <div class="form-group">
              <label for="starting_date">Starting Date (optional)</label>
              <DatePicker
                type="date"
                v-model="form.starting_date"
                placeholder="Select date"
                class="w-100"
              />
              <has-error :form="form" field="starting_date"></has-error>
            </div>
          </div>
          <div class="col-xl-3">
            <div class="form-group">
              <label for="ending_date">Ending Date (optional)</label>
              <DatePicker
                type="date"
                v-model="form.ending_date"
                placeholder="Select date"
                class="w-100"
              />
              <has-error :form="form" field="ending_date"></has-error>
            </div>
          </div>
          <div class="col-xl-12">
            <div class="form-group">
              <label for="Short Description">Short Description</label>
              <quill-editor
                v-model="form.short_description"
                :options="editorOptions"
                style="height: 210px"
              ></quill-editor>

              <has-error :form="form" field="short_description"></has-error>
            </div>
          </div>

          <div class="col-xl-12 text-right mt-5">
            <b-button type="button" @click="PhotClear" variant="danger">
              Clear
            </b-button>

            <b-button type="submit" variant="primary" class="ml-1">
              {{ form.id ? "Update" : "Save" }}
            </b-button>
            <b-button
              variant="primary"
              class="ml-1"
              v-if="allProjectLength > 0 && nextName"
              @click="nextOnboard(nextName, nextTitle)"
            >
              Next
            </b-button>
          </div>
        </div>
      </form>
    </b-card>

    <h2>Portfolio Project</h2>
    <div
      v-if="portfolioProjects.length"
      class="row mt-2 shadow rounded"
      v-for="(project, index) in portfolioProjects"
      :key="index"
    >
      <div class="col-xl-12 border-left">
        <div class="pt-3 pb-3">
          <div class="d-flex justify-content-end">
            <div>
              <b-button variant="primary" size="sm" class="mr-2">
                <a
                  :href="project.link"
                  target="_blank"
                  class="text-decoration-none text-white"
                >
                  <feather-icon icon="GlobeIcon" size="18" />
                </a>
              </b-button>
              <b-button variant="primary" size="sm" @click="edit(project.id)">
                <feather-icon icon="EditIcon" size="18" />
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                class="ml-1 bg-danger border-danger"
                @click="Delete(project.id)"
              >
                <feather-icon icon="TrashIcon" size="18" />
              </b-button>
            </div>
          </div>
          <h3 class="d-flex align-items-end">
            <b>{{ project.title }}</b>
            <i class="ml-1" style="font-size: 14px">{{
              project.description
            }}</i>
          </h3>
          <p v-if="project.starting_date">
            ({{ project.starting_date }} -
            {{ project.ending_date ? project.ending_date : "Running" }})
          </p>
          <p v-if="project.link" class="mb-1">
            <a :href="project.link" target="_blank" rel="noopener noreferrer">
              {{ project.link }}
            </a>
          </p>
          <div class="ml-2" v-html="project.short_description"></div>
          <!-- <p>{{ project.description }}</p> -->
        </div>
      </div>
    </div>

    <div v-if="!portfolioProjects.length" class="text-center">
      <h4>No data found!</h4>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BFormFile,
  BCarouselSlide,
  BCarousel,
} from "bootstrap-vue";
import { HasError } from "vform/src/components/bootstrap5";

export default {
  props: ["title", "nextOnboard", "nextTitle", "nextName", "description"],
  data() {
    return {
      form: new Form({
        id: null,
        title: null,
        link: null,
        starting_date: null,
        ending_date: null,
        short_description: null,
        description: null,
      }),
      allProjectLength: null,
      portfolioProjects: [],
      editorOptions: {
        theme: "snow",
        placeholder: "Enter Description...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"],
          ],
        },
      },
    };
  },
  components: {
    BCard,
    BButton,
    HasError,
    BFormFile,
    BCarousel,
    BCarouselSlide,
  },
  computed: {
    formIsInvalid() {
      return !this.form.title;
    },
  },
  mounted() {
    this.getPortfolio();
  },

  methods: {
    getPortfolio() {
      axios
        .get("/candidate/portfolio")
        .then((res) => {
          this.portfolioProjects = res.data.data;
          this.allProjectLength = this.portfolioProjects.length;
          if (this.allProjectLength > 0) {
            this.$store.dispatch("onboardData");
          }
        })
        .catch((e) => {
          this.e(e.data.error);
        });
    },

    savePortfolio() {
      if (!this.formIsInvalid) {
        this.form
          .post("/candidate/portfolio")
          .then((res) => {
            this.s(res.data.message);
            this.$refs.formReset.reset();
            this.getPortfolio();
          })
          .catch((e) => {
            this.e(e.response.data.message);
          });
      }
    },

    edit(id) {
      axios
        .get("/candidate/portfolio/" + id)
        .then((res) => {
          let portfolio = res.data.portfolio;
          this.form.id = portfolio.id;
          this.form.title = portfolio.title;
          this.form.link = portfolio.link;
          this.form.starting_date = portfolio.starting_date;
          this.form.ending_date = portfolio.ending_date;
          this.form.short_description = portfolio.short_description;
          this.form.description = portfolio.description;
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },

    UpdatePortfolio(id) {
      this.form
        .put("/candidate/portfolio/" + id)
        .then((res) => {
          this.s(res.data.message);
          this.$refs.formReset.reset();
          this.form.id = null;
          this.getPortfolio();
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },

    Delete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("/candidate/portfolio/" + id)
            .then((res) => {
              this.s(res.data.message);
              this.getPortfolio();
            })
            .catch((e) => {
              this.e(e.response.data.message);
            });
        }
      });
    },

    PhotClear() {
      this.$refs.formReset.reset();
      return;
    },
  },
};
</script>
